import { Injectable } from "@angular/core";
import {
    CanLoad,
    Router,
    UrlTree,
} from "@angular/router";
import { LocalizeRouterService } from "@gilsdav/ngx-translate-router";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

// eslint-disable-next-line no-restricted-syntax
@Injectable({ providedIn: "root" })
export class DevModeGuard implements CanLoad {
    constructor(private router: Router,
                private localizeRouterService: LocalizeRouterService) {
    }

    public canLoad():
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const hostUrl = this.localizeRouterService.translateRoute("/");
        if (environment.production && typeof hostUrl === "string") {
            return this.router.parseUrl(hostUrl);
        }
        return !environment.production;
    }
}
